// Despite the name, this is really the company-contacts + company-image
// API - genuinely shared with 13 external files across `_features/
// {contacts,selfServeUsers,company}` and several old-tree picker/deals
// modals (see docs/external-dependency-audit.md). `getAllCustomers` was
// trimmed during the Customers retirement - confirmed its only consumer
// anywhere in the app was the old Customers list page, now deleted.
import { apiSlice } from "../../../_api/apiSlice";

export const customerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addContactByCustomer: builder.mutation({
      query: (data) => ({
        url: `/company/customers/${data.id}/createContact`,
        method: "POST",
        body: data.data,
      }),
    }),
    addContactToCompany: builder.mutation({
      query: (data) => ({
        url: `/company/addContact`,
        method: "POST",
        body: data,
      }),
    }),
    updateContactToCompany: builder.mutation({
      query: (data) => ({
        url: `/company/updateContact`,
        method: "POST",
        body: data,
      }),
    }),
    deleteContactFromCompany: builder.mutation({
      query: (data) => ({
        url: `/company/deleteContact`,
        method: "POST",
        body: data,
      }),
    }),
    getCustomer: builder.mutation({
      query: (id) => ({
        url: `/company/customers/${id}`,
        method: "GET",
      }),
    }),
    removeContactByCustomer: builder.mutation({
      query: (data) => ({
        url: `/company/customers/${data.id}/removeContact`,
        method: "POST",
        body: data.data,
      }),
    }),
    updateCompanyProfileImage: builder.mutation({
      query: ({ companyId, imageFile }) => {
        const formData = new FormData();
        formData.append("image", imageFile);
        formData.append("companyId", companyId);

        return {
          url: `uploads/companyImage`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["Company"],
    }),
  }),
});

export const {
  useGetCustomerMutation,
  useAddContactByCustomerMutation,
  useRemoveContactByCustomerMutation,
  useUpdateCompanyProfileImageMutation,
  useAddContactToCompanyMutation,
  useUpdateContactToCompanyMutation,
  useDeleteContactFromCompanyMutation,
} = customerApiSlice;
